export default __webpack_public_path__ + "static/img5-19531a6cc4104d516d273f729c25a3c1.jpg";